import { defineStore } from 'pinia';
import axios from 'axios';

// Subscriptions admin store (Feature 3/6). Server-side paginated + filterable.
export const useSubscriptionStore = defineStore('subscriptions', {
    state: () => ({
        subscriptions: [],
        pagination: null,
        loading: false,
        acting: false,
        filters: { status: '', plan_type: '', type: '', student_id: '', per_page: 20 },
    }),

    actions: {
        async fetchSubscriptions(page = 1) {
            this.loading = true;
            try {
                const params = { page, per_page: this.filters.per_page };
                ['status', 'plan_type', 'type', 'student_id'].forEach(k => {
                    if (this.filters[k]) params[k] = this.filters[k];
                });
                const { data } = await axios.get('/admin/subscriptions', { params });
                this.subscriptions = data.data.data ?? [];
                this.pagination = data.data;
            } finally {
                this.loading = false;
            }
        },

        async activate(id) {
            this.acting = true;
            try {
                const { data } = await axios.post(`/admin/subscriptions/${id}/activate`);
                return data;
            } finally {
                this.acting = false;
            }
        },

        async cancel(id) {
            this.acting = true;
            try {
                const { data } = await axios.post(`/admin/subscriptions/${id}/cancel`);
                return data;
            } finally {
                this.acting = false;
            }
        },

        // payload: { student_id, type, subscribable_id, plan_type, notes?, activate? }
        async create(payload) {
            this.acting = true;
            try {
                const { data } = await axios.post('/admin/subscriptions', payload);
                return data;
            } finally {
                this.acting = false;
            }
        },
    },
});
